import houseFrontImg from "../assets/images/housefront.png";
import roofSlope from "../assets/images/roofslope.png";
import penetration from "../assets/images/penetration.png";
import ridgecap from "../assets/images/ridgecap.png";
import metalflashings from "../assets/images/metalflashings.png";
import miscellaneous from "../assets/images/miscellaneous.png";

export interface ImageWithMetadata {
    url: string;
    assetId?: string;
    thumbAssetId?: string;
    previewAssetId?: string;
    note?: string | null;
}

export const roofingPhotoSections = [
    {
        id: "frontHouse",
        title: "Front of House",
        label: "TASK:INITIAL_INSPECTION:FHSA",
        description: "Capture a wide shot showing the address and the overall front view of the property.",
        coverImage: houseFrontImg,
    },
    {
        id: "slopeOverview",
        title: "Roof Slope",
        label: "TASK:INITIAL_INSPECTION:OOES",
        description: "Photos showing the condition and angles of each slope of the roof.",
        coverImage: roofSlope,
    },
    {
        id: "penetrationCloseups",
        title: "Penetrations",
        label: "TASK:INITIAL_INSPECTION:COEP",
        description: "Close-up shots of all roof penetrations, including vents, pipes, and other elements.",
        coverImage: penetration,
    },
    {
        id: "metalFlashings",
        title: "Metal Flashings",
        label: "TASK:INITIAL_INSPECTION:AMFL",
        description: "Images of all metal flashings used, including drip edge, step flashings, and more.",
        coverImage: metalflashings,
    },
    {
        id: "ridgeCapNails",
        title: "Ridge Photos",
        label: "TASK:INITIAL_INSPECTION:RCNS",
        description: "Photos of the ridge line, ridge cap, and related ridge details.",
        coverImage: ridgecap,
    },
    {
        id: "miscellaneous",
        title: "Miscellaneous Photos",
        label: "TASK:INITIAL_INSPECTION:MISC",
        description: "Any additional inspection photos that do not fit the categories above.",
        coverImage: miscellaneous,
    },
];
